// // src/theme/colors.js

// export const COLORS = {
//   PRIMARY: "#421A6E",
//   SECONDARY: "#652D90",
//   LIGHT_SECONDARY: "#C5A9D9",

//   TEXT: "#212121",
//   BACKGROUND: "#FFFFFF",
//   GREY_COLOR:"#D9D9D9",
//   // Optional future-proof shades
//   BORDER: "#E0E0E0",
//   MUTED_TEXT: "#6B6B6B"
// };

// export const FONT_FAMILY = "'Montserrat', sans-serif";

// export const TYPOGRAPHY = {
//   DISPLAY_TITLE: {
//     fontSize: "36px",   // 36pt
//     lineHeight: "48px",    fontWeight: 800
//   },

//   H1: {
//     fontSize: "30px",
//     lineHeight: "40px",
//     fontWeight: 700
//   },

//   H2: {
//     fontSize: "24px",
//     lineHeight: "32px",
//     fontWeight: 600
//   },

//   H3: {
//     fontSize: "18px",
//     lineHeight: "24px",
//     fontWeight: 600
//   },

//   H4: {
//     fontSize: "15px",
//     lineHeight: "20px",
//     fontWeight: 500
//   },

//   BODY_LARGE: {
//     fontSize: "13.5px",
//     lineHeight: "18px",
//     fontWeight: 500
//   },

//   BODY_STANDARD: {
//     fontSize: "12px",
//     lineHeight: "16px",
//     fontWeight: 400
//   },

//   BODY_SMALL: {
//     fontSize: "10.5px",
//     lineHeight: "14px",
//     fontWeight: 400
//   },

//   CAPTION_MICRO: {
//     fontSize: "9px",
//     lineHeight: "12px",
//     fontWeight: 300
//   },

// };

// src/constants/color.js

export const COLORS = {
  // Primary Colors (from your file)
  PRIMARY: "#421A6E",
  SECONDARY: "#652D90",
  LIGHT_SECONDARY: "#C5A9D9",
  
  // Text & Background
  TEXT: "#212121",
  BACKGROUND: "#FFFFFF",
  GREY_COLOR: "#D9D9D9",
  BORDER: "#E0E0E0",
  MUTED_TEXT: "#6B6B6B",
  
  // Status Colors (NEW - for badges)
  SUCCESS: "#10B981",      // Green
  SUCCESS_LIGHT: "#D1FAE5",
  WARNING: "#F59E0B",      // Yellow/Orange
  WARNING_LIGHT: "#FEF3C7",
  ERROR: "#EF4444",        // Red
  ERROR_LIGHT: "#FEE2E2",
  INFO: "#3B82F6",         // Blue
  INFO_LIGHT: "#DBEAFE",
  GREEN_LIGHT: "#8CD47E",
  // Additional UI Colors
  CARD_BACKGROUND: "#F9FAFB",
  HOVER_BACKGROUND: "#F3F4F6",
  DISABLED: "#9CA3AF",
  BORDER_COLOR: "#FEFDFF",
  // Sidebar specific
  SIDEBAR_BACKGROUND: "#F8F9FA",
  SIDEBAR_ACTIVE: "#E5E7EB",
  SIDEBAR_HOVER: "#F3F4F6",
};

export const FONT_FAMILY = "'Montserrat', sans-serif";

export const TYPOGRAPHY = {
  DISPLAY_TITLE: {
    fontSize: "36px",
    lineHeight: "48px",
    fontWeight: 800
  },
  H1: {
    fontSize: "30px",
    lineHeight: "40px",
    fontWeight: 700
  },
  H2: {
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: 600
  },
  H3: {
    fontSize: "18px",
    lineHeight: "24px",
    fontWeight: 600
  },
  H4: {
    fontSize: "15px",
    lineHeight: "20px",
    fontWeight: 500
  },
  BODY_LARGE: {
    fontSize: "13.5px",
    lineHeight: "18px",
    fontWeight: 500
  },
  BODY_STANDARD: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 400
  },
  BODY_SMALL: {
    fontSize: "10.5px",
    lineHeight: "14px",
    fontWeight: 400
  },
  CAPTION_MICRO: {
    fontSize: "9px",
    lineHeight: "12px",
    fontWeight: 300
  },
};